module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-80.ec03245a.svg";